import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import VipTag from '@/components/VipTag.vue';
import {useRoute, useRouter} from 'vue-router';
import {Toast} from 'vant';
import {onMounted} from 'vue';
import {getPoster} from '@/api/miscellaneous';
import {listSubscribe} from '@/hooks/listSubscribe';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopHeader',
  props: {
    detail: {
        type: Object,
        Default: () => ({}),
    },
    type: {
        type: String,
        Default: () => 'PurchaseDetail',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const {subscribe, isSubscribe} = listSubscribe();

const router = useRouter();
const route = useRoute();
let isShowshare = ref<any>(false);
let isShowOpen = ref<any>(false);
const imageurl = ref<any>();



onMounted(() => {
    console.log(props.detail, props.type, '---detail----');
});

const tousu = () => {
    router.push({name: 'Report', query: {id: props.detail?.id}});
};
const createPic = () => {
    const {id} = route.query;
    getPoster({id: id as string, type: props.type as string}).then(res => {
        imageurl.value = res as string;
        console.log(res, '--getPoster');
        isShowshare.value = true;
    });
};
const close = () => {
    isShowshare.value = false;
};
const share = () => {
    isShowOpen.value = true;
};
const save = () => {
    Toast('请长按图片，选择保存');
};

const __returned__ = { subscribe, isSubscribe, router, route, isShowshare, isShowOpen, imageurl, props, tousu, createPic, close, share, save, ref, VipTag, useRoute, useRouter, Toast, onMounted, getPoster, listSubscribe }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})